import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgModel, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { PortfolioHubService } from '../../../../techopsv4/services/portfolioHubV4Service';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';

@Component({
    selector: 'app-delete-lob',
    templateUrl: './delete-lob.component.html',
    styleUrls: ['./delete-lob.component.css'],
    providers: [NgModel],
    imports: [MatFormField, MatSelect, FormsModule, MatOption, LoaderComponent]
})
export class DeleteLobComponent {
  @Input() deletedRow;
  
  segmentList=[{SegID: 'S0001', MasterSegment: 'Optum'},
  {SegID: 'S0002', MasterSegment: 'UHC'},
  {SegID: 'S0003', MasterSegment: 'UHG'},
  {SegID: 'S0004', MasterSegment: 'Other'}];
  @Input() lobDatasource;
  selectedSegment;
  lobList: any;
  selectedLob;
  subLobList:any;
  selectedSubLob;
  disableSubmit = true;
  previousSelection: [];
  searchTxt = '';
  searchTxtsub = '';
  tempLobList: any;
  selectedCategory = [{id:1, name: 'Application'},{id:2, name:'Application Suite'}, {id:3, name:'Infrastructure'}, {id:4, name:'NON AIDE Specific'}]
  selectedLifecycle =  [{ id: 1, name: 'Production' }, { id: 2, name: 'In Development' }, { id: 3, name: 'Decommissioned' }, { id: 4, name: 'NON AIDE Specific' }];

  selectedOption = 'lob';
  @Output() deleteSuccessEvent : EventEmitter<any> = new EventEmitter();
  showLoader: boolean = false;
  tempSubLobList: any;

  constructor(private maintenanceService : MaintenanceService,
    private toaster: ToastrService,
    private router: Router,
    private portfolioService: PortfolioHubService,
    private ngmodel:NgModel
    ) { }

  getLobList() {
    
    this.selectedLob = null;
    this.selectedSubLob = null;
    this.disableSubmit = true;
    this.searchTxt = '';
    this.subLobList = [];
    this.lobList = this.lobDatasource.filter(x => x.MasterSegment === this.selectedSegment.MasterSegment)
    this.tempLobList = this.lobList;
  }

  getSubLobList() {
    this.searchTxtsub = '';
    this.searchTxt = '';
    this.selectedSubLob = null;
    this.disableSubmit = true;
    this.subLobList = (this.lobList.filter(x => x.LobID === this.selectedLob.LobID).map(x => x.sublob))[0];
    this.subLobList = this.subLobList.filter(x => x.SubLobID != this.deletedRow.SubLobID);
    this.lobList = this.tempLobList;
    this.tempSubLobList = this.subLobList;
  }

  onSubLobChange() {
    this.subLobList = this.tempSubLobList;
    this.searchTxtsub = '';
    this.disableSubmit = false;
  }

  submit() {
    this.showLoader = true;
    const payload = {
      "source" : {
        "SubLobID": this.deletedRow.SubLobID,
        "lob_id": this.deletedRow.LobID,
        "sub_lob": this.deletedRow.SubLineofBusiness,
        "lob":  this.deletedRow.CIOLOB
      },
  
      "destination" : {
      "lob_id": this.selectedLob.LobID,
      "sub_lob": this.selectedSubLob.SubLineofBusiness,
      "SubLobID": this.selectedSubLob.SubLobID,
      "lob": this.selectedLob.CIOLOB
      }
    }
    this.maintenanceService.deleteSubLOB(payload).subscribe(data => {
      if (data) {
        this.showLoader = false;
        this.deleteSuccessEvent.emit();
        this.toaster.success('SubLOB deleted Successfully!', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
      }
    },
    (error) => {
      this.showLoader = false;
      console.log(error);
      this.toaster.error(error.error.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    })
  }

  search(type) {
    if (type === 'lob') {
      this.lobList = this.tempLobList.filter(x => x.CIOLOB.toString().toLowerCase().indexOf(this.searchTxt.toLowerCase()) > -1);
    } else if (type === 'sublob') {
      this.subLobList = this.tempSubLobList.filter(x => x.SubLineofBusiness.toString().toLowerCase().indexOf(this.searchTxtsub.toLowerCase()) > -1);
    }
  }

  navigateToPortfolio() {
    const lobId = [];
    lobId.push(this.deletedRow.LobID);
    const sublobId = [];
    sublobId.push(this.deletedRow.SubLobID);
    let segment;
    this.portfolioService.getSegmentLists().subscribe(data => {
      segment = data.Master_Segment;
      sessionStorage.setItem('segmentList', JSON.stringify(segment));
    });

    sessionStorage.setItem('lob', JSON.stringify(lobId))
    sessionStorage.setItem('sublob',JSON.stringify(sublobId))
    const searchFilters = {
      'SubLOB_ID': sublobId,
      'App_Lifecycle_Status': this.selectedLifecycle.map(x => x.name)
    }

    const selectedSegement = [{name: this.deletedRow.MasterSegment}];
    const baseUrl = window.location.href.replace(this.router.url, '');
    const apphubUrl = baseUrl + '/portfolio-hub/search?searchFilters=' + encodeURIComponent(JSON.stringify(searchFilters)) 
      +'&category='+ JSON.stringify(this.selectedCategory)
      + '&lifecycle='+JSON.stringify(this.selectedLifecycle)+'&segment='+JSON.stringify(selectedSegement)
      + '&selectedOption='+this.selectedOption;
    window.open(apphubUrl, '_blank');
  }

  resetValue(){
    this.searchTxt = " ";
     this.ngmodel.reset(this.searchTxt);
     this.lobList = this.lobDatasource.filter(x => x.MasterSegment === this.selectedSegment.MasterSegment)
   }
}
